export const SITE_ENDPOINT = {
  HOME: 'home',
  BASE: '/home/apps/',
  COMPANY: {
    INDEX: 'company',
    VIEW_COMPANY: 'company/view',
    EDIT_COMPANY: 'company/edit',
    CREATE_COMPANY: 'company/create'
  },
  JOB: {
    EDIT: 'job/edit',
    INDEX: 'job'
  },
  JOB_TYPE: 'job-type'
};
